import { Layout } from '@/core/layout/layout';
import { type RouteRecordRaw } from 'vue-router';

export default {
    path: '/thank-you',
    component: () => import('../views/Global/ThankYou.vue'),
    meta: {
        title: 'THANK_YOU',
        layout: Layout.HeaderOnly,
    },
    children: [
        {
            path: 'identification',
            name: 'thank-you-identification',
            component: () => import('../components/ThankYou/ThankYouIdentification.vue'),
        },
        {
            path: 'signing',
            name: 'thank-you-signing',
            component: () => import('../components/ThankYou/ThankYouSigning.vue'),
        },
        {
            path: 'subscription',
            name: 'thank-you-subscription',
            component: () => import('../components/ThankYou/ThankYouSubscription.vue'),
        },
        {
            path: 'advisor-access',
            name: 'thank-you-advisor-access',
            component: () => import('../components/ThankYou/AdvisorAccess.vue'),
        },
        {
            path: ':(.*)',
            redirect: { name: 'dashboard' },
        },
    ],
} as RouteRecordRaw;
